class DefaultLog {
  trace(message) {
    window.console && console.trace(message);
  }
  info(message) {
    window.console && console.info(message);
  }
  debug(message) {
    window.console && console.debug(message);
  }
  warn(message) {
    window.console && console.warn(message);
  }
  error(message) {
    window.console && console.error(message);
  }
}
/**
 *  前端日志记录
 */
export class Logger {
  constructor(context) {
    this.context = context || 'default';
    this.log = new DefaultLog();
  }
  buildMessage(message) {
    const msg = '当前上下文：' + this.context + ',错误消息：' + message;
    return msg;
  }
  debug(message) {
    const msg = this.buildMessage(message);
    const logger = this._getLogger();
    logger.debug(msg, null, null);
  }
  info(message) {
    const msg = this.buildMessage(message);
    const logger = this._getLogger();
    logger.info(msg, null, null);
  }
  warn(message, error, event) {
    const msg = this.buildMessage(message);
    const logger = this._getLogger();
    logger.warn(msg, error, event);
  }
  error(message, error, event) {
    const msg = this.buildMessage(message);
    const logger = this._getLogger();
    logger.error(msg, error, event);
  }
  _getLogger() {
    return this.log;
  }
}
